'use client'

import classNames from 'classnames'
import { FC, PropsWithChildren } from 'react'

interface PillProps extends PropsWithChildren {
	color?: string
	background?: string
}

const Pill: FC<PillProps> = ({
	color = 'black',
	background = 'positive/15',
	children,
}) => {
	return (
		<span
			className={classNames(
				'inline-block px-2 lg:px-3 py-1 text-xs font-semibold rounded-full',
				`text-${color} bg-${background} `
			)}
		>
			{children}
		</span>
	)
}

export default Pill
